import axios from 'axios';

axios.defaults.timeout = 40000;
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.API_HOST;

// 请求拦截器配置
axios.interceptors.request.use(set => {
  set.headers = {
    'Content-Type': 'application/json',
  };

  return set;
}, err => {
  return Promise.reject(err);
});

/**
 * post请求
 */
function doPost(url, params = {}){
  const promise = new Promise((resolve, reject) => {
    axios.post(url, params, {withCredentials: true})
      .then(resp => {
        resolve(resp.data);
      }, err => {
        reject(err);
      });
  });

  return promise;
}

/**
 * post请求
 */
function doGet(url, params = {}){
  const promise = new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(resp => {
      resolve(resp.data);
    }, err => {
      reject(err);
    });
  });

  return promise;
}

export default {
  doPost,
  doGet,
}



// WEBPACK FOOTER //
// ./src/api/http.js